import { decode } from 'js-base64';
import { NotificationCard } from '../../components/Card';
import { Center, Flex, Icon } from '@chakra-ui/react';
import { NotificationTime } from '../../components/Time';
import { Calendar } from '@kula-ai/icons/outline/Calendar';
import {
  JoinInterviewButton,
  MeetingDetailsContainer,
  NotificationMessage,
  ReviewCandidateButton,
  SendMessageButton,
} from './components';

const MeetingStartsIn10Mins = ({ notification = {}, onClose = () => {} }) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));
  const { candidate, interview_name, interview_url, meeting_url, job_name } =
    data;
  const { name: candidateName, url } = candidate;
  const contact_id = url.split('/').pop();
  const interview_id = interview_url.split('/').pop();

  const messageData = {
    interview: { name: interview_name, url: `/interviews/${interview_id}` },
    candidate: { name: candidateName, url: `/contacts/${contact_id}` },
    time: '10 minutes',
    job: { name: job_name },
  };
  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="34px" h="34px" borderRadius="sm" bg="primary-100">
        <Icon as={Calendar} color="primary-500" width="16px" />
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start">
        <NotificationMessage
          template="STARTING_SOON"
          data={messageData}
          onClose={onClose}
          notification={notification}
        />
        <MeetingDetailsContainer data={data} isCollapsable={false} />
        <Flex flexDir="column" gap="6px">
          <ReviewCandidateButton
            interviewUrl={interview_url}
            notification={notification}
            variant="primary"
          />
          {meeting_url && (
            <JoinInterviewButton
              meetingUrl={meeting_url}
              notification={notification}
            />
          )}
          <SendMessageButton
            interviewUrl={interview_url}
            notification={notification}
            variant="tertiary"
          />
        </Flex>
        <NotificationTime notification={notification} />
      </Flex>
    </Flex>
  );
};

export const MeetingStartsIn10MinsNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <MeetingStartsIn10Mins notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
